<div class="messenger-contact bg-linear" *ngIf="contact">
  <div class="contact-online online">
    <img class="messenger-contract-img" userAvatar [usercode]="contact.usercode">
    <div class="messenger-contact-name">{{contact.fullname || contact.usercode}}</div>
  </div>
  <div style="white-space: nowrap">

    <button class="btn btn-primary btn-custom-primary rounded-pill border-0"
            *ngIf="audioCall && profile !== contact.usercode"
            (click)="joinRoom(true)">
      <i class="fa fa-phone"></i>
    </button>
<!--    <i class="message-chat__action fa fa-phone" *ngIf="audioCall && profile !== contact.usercode"-->
<!--       (click)="joinRoom(true)"></i>-->
    <!--        <i class="message-chat__action fa fa-video-camera" *ngIf="videoCall && profile !== contact.usercode" (click)="joinRoom(false)"></i>-->
    <i class="message-chat__action fa fa-times" *ngIf="closable" (click)="onClose.emit(contact)"></i>
  </div>
</div>
<div #messageBody class="messenger-body">
  <div class="message-video">
    <!--<div *ngIf="videoPanelVisible" class="container text-center mb-2" style="background: #000000;min-height: 200px;">-->
    <!--<h5 class="text-white" style="padding: 40px;">Đang có cuộc trò chuyện</h5>-->
    <!--<button class="btn btn-success" (click)="joinRoom(false)">Tham gia</button>-->
    <!--</div>-->
    <div id="meet" class="container-video-meet" [ngClass]="{'hide': videoPanelVisible}"></div>
  </div>
  <div class="message-content">
    <div *ngFor="let holder of holders">
      <div class="messenger-date-group">{{holder.display}}</div>
      <div *ngFor="let message of holder.messages" class="messenger-chat"
           [ngClass]="{'sent': message.isSent}">
        <img *ngIf="message.displayText!==''"
             [ngClass]="!message.isSent ? 'messenger-chat-image': 'messenger-chat-image-receive'" userAvatar
             [usercode]="message.message.sender">
        <div class="messenger-chat-content">
          <!--                    <file-list [files]="message.attachments" [removable]="false" (onClick)="viewAttachment($event)"-->
          <!--                               class="messenger-chat__file"></file-list>-->
          <app-link-preview *ngIf="message._openGraph" [openGraphData]="message._openGraph"
                            [removable]="false" class="social-block"></app-link-preview>
          <div class="row justify-content-center p-0 m-1 align-items-center"
               *ngIf="arraySendImage(message.attachments).length <= 3">
            <div *ngFor="let imageOrFileSend of arraySendImage(message.attachments)" style="align-items: center;">
              <img *ngIf="imageOrFileSend.image" class="image-content col-sm-4 p-0 m-1"
                   (click)="viewImage(); currentImage(imageOrFileSend, arraySendImage(message.attachments))"
                   [title]="imageOrFileSend.name" [alt]="imageOrFileSend.name"
                   [src]="imageOrFileSend.url || defaultImage ">
            </div>
          </div>
          <div class="row justify-content-center p-0 m-1 align-items-center"
               *ngIf="arraySendImage(message.attachments).length > 3">
            <div *ngFor="let imageOrFileSend of message.attachments.slice(0,2)" style="align-items: center;">
              <img *ngIf="imageOrFileSend.image" class="image-content col-sm-4 p-0 m-1 cursor"
                   (click)="viewImage(); currentImage(imageOrFileSend, arraySendImage(message.attachments))"
                   [title]="imageOrFileSend.name" [alt]="imageOrFileSend.name"
                   [src]="imageOrFileSend.url || defaultImage ">

            </div>
            <div class="image-blur col-sm-4 p-0 cursor"
                 (click)="viewImage(); currentImage(imageOrFileSend, arraySendImage(message.attachments))"
                 *ngFor="let imageOrFileSend of arraySendImage(message.attachments).slice(2,3)"
                 [title]="showNameFileSend(arraySendImage(message.attachments))">
              <div [ngClass]="{'image-plus': imageOrFileSend.image}">
                <img *ngIf="imageOrFileSend.image" class="image-content col-sm-4 p-0 m-1 "
                     [title]="imageOrFileSend.name" [alt]="imageOrFileSend.name"
                     [src]="imageOrFileSend.url || defaultImage ">
              </div>
              <div class="plus-image col-sm-12 text-show-plus-image p-0 ml-1">
                + {{arraySendImage(message.attachments).slice(2, arraySendImage(message.attachments).length).length}}
              </div>
            </div>
          </div>

          <div class="row justify-content-end p-0 m-1 align-items-center"
               *ngIf="arraySendFile(message.attachments).length <= 3">
            <div *ngFor="let imageOrFileSend of arraySendFile(message.attachments)" class="m-2">
              <div [title]="imageOrFileSend.name">
                <img *ngIf="!imageOrFileSend.image" class="file-content col-sm-4 p-0 ml-1 mr-4 mb-1 mt-3"
                     [src]="imageOrFileSend.name|fileIcon"
                     [alt]="imageOrFileSend.name">
                <div *ngIf="!imageOrFileSend.image" class="text-truncate text-center " style="max-width: 90px">
                  <a [href]="imageOrFileSend.url">{{imageOrFileSend.name}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-end p-0 m-1 align-items-center"
               *ngIf="arraySendFile(message.attachments).length > 3">
            <div *ngFor="let imageOrFileSend of arraySendFile(message.attachments).slice(0,2)" class="m-2">
              <div [title]="imageOrFileSend.name">
                <img *ngIf="!imageOrFileSend.image" class="file-content col-sm-4 p-0 ml-1 mr-4 mb-1 mt-3"
                     [src]="imageOrFileSend.name|fileIcon"
                     [alt]="imageOrFileSend.name">
                <div *ngIf="!imageOrFileSend.image" class="text-truncate text-center align-middle"
                     style="max-width: 90px">
                  <a class="align-middle" [href]="imageOrFileSend.url">{{imageOrFileSend.name}}</a>
                </div>
              </div>
            </div>
            <div class="file-blur col-sm-4 p-0 m-3"
                 *ngFor="let imageOrFileSend of arraySendFile(message.attachments).slice(2,3)"
                 [title]="showNameFileSend(arraySendFile(message.attachments))">
              <div [ngClass]="{'file-plus' : !imageOrFileSend.image}">
                <img *ngIf="!imageOrFileSend.image" class="file-content col-sm-4 p-0 m-1"
                     [src]="imageOrFileSend.name|fileIcon"
                     [alt]="imageOrFileSend.name">
              </div>
              <div class="plus-image col-sm-12 text-show-plus-image p-0 ml-1">
                + {{arraySendFile(message.attachments).slice(2, arraySendFile(message.attachments).length).length}}
              </div>
            </div>
          </div>
          <span class="text-truncate" *ngIf="!message._openGraph" [innerHTML]="message.displayText | safeHtml"></span>
          <div class="messenger-chat-time text-secondary" [title]="message.longTime">{{message.shortTime}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="messenger-footer">
  <file-list #fileList fileList [fileEl]="fileEl" (onRemoveAll)="removeAllFile($event)" (onRemove)="removeFile($event)"
             [files]="files"></file-list>
  <div class="messenger-footer-inner">
    <div class="messenger-footer-input">
      <textarea type="text" #input autosize (keyup.enter)="sendMessage()" placeholder="Nhập nội dung ..."></textarea>
    </div>
    <label class="message-chat__action_attach btn- btn-primary btn-custom-primary border-0 fa fa-image" style="margin-bottom: 0;">
      <input #fileEl type="file" (change)="input.focus()" multiple style="display:none">
    </label>
    <!--        <label class="message-chat__action img-send-file" style="margin-bottom: 0;">-->
    <!--          <input #fileEl type="file" (change)="input.focus()" multiple style="display:none">-->
    <!--        </label>-->
    <i *ngIf="canSend" (click)="sendMessage()"
       class=" message-chat__action_attach btn- btn-primary btn-custom-primary border-0 fa fa-arrow-right"
       aria-hidden="true"></i>
  </div>
</div>
<i *ngIf="loading" class="messenger-spinner fa fa-spinner fa-spin"></i>


<div *ngIf="loadImage" class="view-image p-0">
  <div *ngIf="loadImage" class="load-image-close fa fa-times" (click)="viewImage()"></div>
  <div class="load-image-content p-0">
    <a *ngIf="arrSendImage.length > 1" class="prev" (click)="prev(arrSendImage, imageShow)">&#10094;</a>
    <div class="d-flex justify-content-center align-items-center image-show">
      <img [src]="imageShow.url || defaultImage " class="mw-100 mh-100" alt="{{imageShow.name}}">
    </div>
    <a *ngIf="arrSendImage.length > 1" class="next" (click)="next(arrSendImage, imageShow)">&#10095;</a>
    <h6 class="text-center text-white mt-3">{{imageShow.name}}</h6>
    <div class="list-item-image-select mt-2 scroll-list-send d-flex p-0 ">
      <div *ngFor="let attach of arrSendImage" (click)="currentImage(attach, arrSendImage)"
           [title]="attach.name"
           [ngClass]="attach === imageShow ? 'images-active' : 'images-none'">
        <img [src]="attach.url || defaultImage " class="file-item__image_type hover-shadow cursor">
      </div>
    </div>
  </div>
</div>
